import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=54848640&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54848640",
  null
  
)

export default component.exports